import React, { useState, useEffect } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import API_CONSTANTS from './../../api-constants'
import { useHistory } from 'react-router-dom'


const AdminProfile = ({ iframeId, appHeightChanged , orgID}) => {
  
    const location = useLocation();
    const logins = location?.state?.login_info
    const key = sessionStorage.getItem('key')
    const history = useHistory();

    let current_pw = sessionStorage.getItem('login_pw')
  
    const [profileChanged, setProfileChanged] = useState(false)
    const [tlfNumber, setTlfNumber] = useState(logins?.Phone);
    const [name, setName] = useState(logins?.Name);
    const [email, setEmail] = useState(logins?.EMail)
    const [password, setPassword] = useState('');
 
    const isValidName = /^[a-z ,.'-]+$/i
   
    const [resetpwError, setResetpwError] = useState(false)
    const [error, setError] = useState(false)
    const [nameError, setNameError] = useState('')
    const [numberError, setNumberError] = useState('')
   
    const [networkError, setNewtorkError] = useState('')

  

  
    if (window.parent != window) {
        appHeightChanged(iframeId, true)
    }

    const validateName = (e) => {
        if (e.target?.value && e.target.value.match(isValidName)) {
            setName(e.target.value)

        }
    }
    function handleNameChange(e) {
        validateName(e)
        setName(e.target.value)
        setNameError('')
        setError('')

    }

    function handleNumberChange(e) {
        const value = e.target.value.replace(/\D/g, "");
       // console.log(value)
        setTlfNumber(value);
        setNumberError('')
        setError('')
    }

  

    function encodeBase64(str) {
        return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    }
  
    function handleSubmit() {
        if (name === '' || tlfNumber === '') {
            setError(true)
        }
      
        if (name === '') {
            setNameError('Udfyld venligst navn')
        }
        if (tlfNumber === '') {
            setNumberError('Udfyld venligst telefonnummer')
        }
       
        if (name.length && !name.match(isValidName)) {
            setNameError('Kun bogstaver i navnet')
        }

        if (tlfNumber !== '' && tlfNumber.length !== 8) {
            setNumberError('Nummeret er forkert')
        }
       
        else if (name.length && name.match(isValidName) && tlfNumber.length === 8) { 
            let encoded_password = encodeBase64(current_pw)

            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Save?Key=${key}&Email=${email}&Password=${encoded_password}&Name=${name}&Phone=${tlfNumber}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
        })
            .then((res) => res.json())
            .then(result => {
            
                if (result.result === 1) {
                   // sessionStorage.removeItem('key')
                    setProfileChanged(true)
                    sessionStorage.setItem('login_pw', password)
                   // sessionStorage.setItem('newkey', result.key)
                                     
                }
                else {
                    setError(true)
                    setNewtorkError(result.Message)
                }
            })

        }
    }

   

    function deleteProfile() {

    }

    function resetPassword() {
        sessionStorage.removeItem('login_info')
        sessionStorage.removeItem('login_pw')
        sessionStorage.removeItem('key')
        let url = `${API_CONSTANTS.fetchUrl}/newpassword`
        
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/SendResetPassword?Email=${email}&URL=${url}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then((res) => res.json())
            .then((result) => {
                //  console.log(result, 'result')

            if (result.result === 1) {
            
                    history.push('/resetpasswordsuccess')
                }
                else {
                    setError(true)
                    setResetpwError(result.Message)
                }
            })
    }
    

    return (
        <main>
           
            <p style={{ color: orgID == 0 ? '#f1c895' : '' }} className='profile-title'>Administrer profil</p>
            {profileChanged === true ? <p style={{fontSize:'20px'} }> Din profil oplysninger er nu opdateret!</p> 

            : <form className='loginflow  ' style={{marginTop:'20px'} }>
                <label for='email' className='email-label'>Email</label>
                <input autoComplete='email' id='email' className='email-input' value={email} />
                <label for='name' className='email-label'>Navn</label>
                 <input autoComplete='name' id='name' className='email-input' type='text' value={name} onChange={handleNameChange}></input>
                 <label for='number' className='email-label'>Telefonnummer</label>
                 <input autoComplete='name' id='number' className='email-input' maxLength='8' type='text' placeholder='Indtast telefonnummer' onChange={handleNumberChange} value={tlfNumber}></input>
              
                <button type="submit" className='send_btn' onClick={handleSubmit}>Gem profiloplysninger</button>
                {error === true ?
                        <div className='error-div'>
                        {networkError && <span>{networkError}</span>}
                        {nameError && <span>{nameError}</span>}
                        {numberError && <span>{numberError}</span>}
                       
                        {resetpwError && <span>{resetpwError}</span> }
                        </div> : null}
                    <div style={{ display: 'flex', justifyContent:'space-between' }}>
                    <button className='delete-profile' onClick={deleteProfile}>Slet profil</button>
                    <button className='delete-profile' onClick={resetPassword}> Nulstil adgangskode</button>
                    </div>

            </form>
            }
        </main>
    )
}

export default AdminProfile